import React, { useState } from 'react'
import './index.scss'
import { Toast } from 'antd-mobile'

const MIN_COUNT = 10

const RecycleConfirmModal = ({ onClose, onConfirm, holdCount = 0 }) => {
  const hold = Number(holdCount) || 0
  const [count, setCount] = useState(MIN_COUNT)
  const [inputVal, setInputVal] = useState(String(MIN_COUNT))

  const applyCount = (value) => {
    const cap = hold > 0 ? hold : value
    const num = Math.min(cap, Math.max(MIN_COUNT, value))
    setCount(num)
    setInputVal(String(num))
    return num
  }

  const onMinus = () => {
    if (count <= MIN_COUNT) return
    applyCount(count - 1)
  }

  const onPlus = () => {
    if (hold > 0 && count >= hold) return
    applyCount(count + 1)
  }

  const onInputChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '')
    setInputVal(raw)
    if (raw === '') return
    const num = parseInt(raw, 10)
    if (Number.isNaN(num)) return
    if (hold > 0 && num > hold) {
      setCount(hold)
      setInputVal(String(hold))
      return
    }
    setCount(num)
  }

  const onInputBlur = () => {
    const num = parseInt(inputVal, 10)
    if (Number.isNaN(num) || num < MIN_COUNT) {
      applyCount(MIN_COUNT)
      return
    }
    applyCount(num)
  }

  const handleConfirm = () => {
    const num = applyCount(parseInt(inputVal, 10) || 0)
    if (hold < MIN_COUNT) {
      Toast.show('持有宝石不足10个')
      return
    }
    onConfirm && onConfirm(num)
  }

  return (
    <div className="gemstone-recycle-confirm">
      <div className="recycle-confirm-outer">
        <div className="recycle-confirm-close" onClick={onClose}></div>
        <div className="recycle-confirm-title">确认回收</div>
        <div className="recycle-confirm-tip">请选择回收个数，10个宝石起</div>
        <div className="recycle-confirm-stepper">
          <div
            className={`recycle-confirm-circle ${count <= MIN_COUNT ? 'disabled' : ''}`}
            onClick={onMinus}
          >
            <span className="recycle-confirm-minus"></span>
          </div>
          <input
            className="recycle-confirm-input"
            type="tel"
            inputMode="numeric"
            value={inputVal}
            onChange={onInputChange}
            onBlur={onInputBlur}
          />
          <div
            className={`recycle-confirm-circle ${hold > 0 && count >= hold ? 'disabled' : ''}`}
            onClick={onPlus}
          >
            <span className="recycle-confirm-plus"></span>
          </div>
        </div>
        <div className="recycle-confirm-btns">
          <div className="recycle-confirm-btn" onClick={onClose}>取消</div>
          <div className="recycle-confirm-btn" onClick={handleConfirm}>确认回收</div>
        </div>
      </div>
    </div>
  )
}

export default RecycleConfirmModal
